import React from 'react';

import { Informer } from '@/shared/ui';

import { UserRequestsTab } from '../model';

interface Props {
  tab: UserRequestsTab;
  className?: string;
}

export const UserRequestsInformers: React.FC<Props> = ({ tab, className = '' }) => {
  switch (tab) {
    case 'active':
      return (
        <Informer
          className={className}
          icon={{
            name: 'info',
            color: 'blue',
          }}
          text={{
            text: 'Для відображення даних по заявкам, що були зареєстровані в системі Єдиного реєстру зброї, необхідно заповнити всі дані в Профілі користувача.',
            color: 'black',
          }}
          borderColor="blue"
        />
      );

    default:
      return <React.Fragment />;
  }
};
